/*----------------------------------------------------------------------------------------
Frontend of the cell component explorer interface

Alex Zhuang || September 2020
----------------------------------------------------------------------------------------*/
import React, { Component } from 'react';
import './App.css';
/*import { makeStyles } from '@material-ui/core/styles';*/
import { Card, Ref, Popup, Placeholder, Header, Icon, Modal, Button } from "semantic-ui-react";
import "regenerator-runtime/runtime";
import { SeqViz } from "./components/viewer.js"
import Grid from '@material-ui/core/Grid';
import MainTable from "./components/table.jsx"
import Filters from "./components/filters.jsx"

const openInNewTab = (url) => {
  const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
  if (newWindow) newWindow.opener = null
}

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rows: [],
      scrollindex: 0,
      accessionCode: "",
      lastSelected: "",
      lastFocus: null,
      focus: null,
      descLoadState: 0,
      seqLoadState: 0,
      descName: "Description",
      desc: "",
      descLink: "",
      seqLink: "",
      windowHeight: window.innerHeight,
      openModal: false
    };
    this.SeqViewer = React.createRef();
    this.queryRows = this.queryRows.bind(this)
    this.getID = this.getID.bind(this)
    this.getText = this.getText.bind(this)
    this.seqStateHandler = this.seqStateHandler.bind(this)
    this.setFocus = this.setFocus.bind(this);
    this.removeFocus = this.removeFocus.bind(this);
  }

  removeFocus = () => {
    this.setFocus(null)
  }

  setFocus = (focus) => {
    this.setState(prevState => ({
      lastFocus: prevState.focus,
      focus: focus
    }))
  }

  handleResize = (e) => {
    this.setState({ windowHeight: window.innerHeight });
  };

  queryRows = async (functionCode, cellCode, focusCode) => {
    let res = await fetch('https://synbioapi.online/get_sheet_data?fcode='
      + functionCode.toString() + "&ccode=" + cellCode.toString()
      + "&focus=" + focusCode)
    res = await res.json()
    this.setState({
      rows: res.rows,
      scrollindex: res.scroll_index
    })
    console.log("set rows", res.rows)
  }

  getID = async (selected, text) => {
    if (this.state.lastSelected === selected) {
      return
    } else {
      this.setState({
        descLoadState: 1,
        seqLoadState: 1,
        descName: text,
        lastSelected: selected
      })
      let res = await fetch("https://synbioapi.online/get_accession_id?code=" + selected)
      res = await res.json()
      console.log('code', selected, 'accession', res, 'loadstate', this.state.descLoadState)
      this.setState({
        accessionCode: res.accession,
        descLink: "https://www.uniprot.org/uniprot/" + selected,
        seqLink: "https://www.ncbi.nlm.nih.gov/nuccore/" + res.accession + "?report=graph",
      })
    }
  }

  getText = async (description) => {
    //this is always called as a result of getID being called
    this.setState({
      //descName: description.name
      desc: description.text,
      descLoadState: 2
    })
  }

  seqStateHandler = (targetState) => {
    this.setState({
      seqLoadState: targetState
    })
  }

  renderDescription(state) {
    switch (state) {
      default:
        return <Card style={{ display: "table", width: "100%", margin: "0", height: "calc(100% - 46px)" }}>
          <Card.Content textAlign="center" content="Select a protein to view its description"
            style={{
              fontFamily: "Lato", fontSize: "medium", color: "darkgray", background: "whitesmoke",
              verticalAlign: "middle", display: "table-cell"
            }} />
        </Card>
      case 1:
        return <Card style={{ display: "block", width: "100%", margin: "0", height: "calc(100% - 46px)" }}>
          <Card.Content style={{ display: "block", height: "100%", overflow: "auto" }}
            content={<Placeholder fluid>
              <Placeholder.Line />
              <Placeholder.Line />
              <Placeholder.Line />
              <Placeholder.Line />
              <Placeholder.Line />
              <Placeholder.Line />
            </Placeholder>} />
        </Card>
      case 2:
        return <Card style={{ display: "block", width: "100%", margin: "0", height: "calc(100% - 46px)", overflow: "auto" }}>
          <Card.Content textAlign="left" content={this.state.desc ? this.state.desc : "An expository description was not found on the GenBank record. "}
            style={{ display: "block", lineHeight: "1.6em" }} />
        </Card>
    }
  }

  closeModal = () => this.setState({ openModal: false })
  openModal = () => this.setState({ openModal: true })

  componentDidMount() {
    window.addEventListener("resize", this.handleResize);
  }

  componentWillUnMount() {
    window.addEventListener("resize", this.handleResize);
  }


  render() {
    let offsetTop = this.SeqViewer.current ? this.SeqViewer.current.getBoundingClientRect().top + 15 : null;
    let viewerHeight = offsetTop ? this.state.windowHeight - offsetTop + "px" : "auto";
    return (
      <div className="App">
        <div style={{ height: "100vh" }}>
          <div className="App-header" >
            <h1 style={{ display: "flex", justifyContent: "flex-start", width: "100%" }}>
              <div>REMEDI</div>
              <Icon style={{ fontSize: "large", margin: "0", paddingLeft: "1em" }} color="grey"
                name="question circle" onClick={() => this.openModal()} />
            </h1>
          </div>
          {/*Info Modal*/}
          <Modal size={'large'} closeOnEscape={true} closeOnDimmerClick={true}
            dimmer={'blurring'} open={this.state.openModal} onClose={this.closeModal}>
            <Modal.Header style={{ fontSize: "x-large", fontWeight: 900, fontFamily: "Lustria" }}>
              Repository of Modular Elements Derived from the Immune System</Modal.Header>
            <Modal.Content>
              <Header> Organizing components of the immune system.</Header>
              <p>As synthetic biologists we work to engineer cell signalling pathways and 
                regulatory mechanisms, but our work is often obstructed by a lack of 
                organization; of specific information about the components of a given cell type's 
                response, and of broader resources that untangle the complexity of
                immune effectors. It is particularly true that limited structured guidance exists
                for gene circuit engineering in human cells, and is therefore an emerging need.</p>
              <p>
                Here, we aim to bridge this gap by viewing the immune system as a source of usable genetic
                components for engineering synthetic signaling pathways, rewiring natural signaling pathways 
                and creating novel molecular tools. To organize and better expose expert knowledge in immunology 
                literature, we created the REpository of Modular Elements Derived from the Immune System (REMEDI).
                It is our hope that the components and pathways standardized on REMEDI can be applied broadly in
                areas of basic research, therapeutics and diagnostics. 
              </p>

              {/*<Header>The Idea</Header>
              <p>
                Gotta write stuff here about what this app does. 
              </p>
            <Header>Building Immunological Circuits</Header>
              <p> How do I use this stuff, general workflow here.
              </p>
            <Header>Citations</Header>
            <p>
              Seqviz, and the paper we're about to publish
            </p>*/}
            </Modal.Content>
            <Modal.Actions style={{ background: 'black' }}>
              <Button labelPosition='right' style={{ fontWeight: 900, fonSize: "medium", color: "white" }} onClick={this.closeModal}>OK</Button>
            </Modal.Actions>
          </Modal>
          {/*Main App*/}
          <div style={{ paddingRight: "1rem", paddingLeft: "1rem", paddingTop: "1rem", paddingBottom: "1rem" }}>
            <Grid container spacing={2}>
              <Grid item xs={7}>
                <Grid container direction="column" spacing={2}>
                  <Grid item>
                    <Filters
                      queryRows={this.queryRows}
                      setFocus={this.setFocus}
                      removeFocus={this.removeFocus}
                      lastFocus={this.state.lastFocus}
                      focus={this.state.focus} />
                  </Grid>
                  <Grid item>
                    <MainTable
                      rows={this.state.rows}
                      getID={this.getID}
                      windowHeight={this.state.windowHeight}
                      setFocus={this.setFocus}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={5}>
                <Grid container direction="column" spacing={2}>
                  {/* DESCRIPTION BOX */}
                  <Grid item style={{ paddingTop: "9px" }}>
                    <Card style={{ height: "20vh", width: "100%", display: "block" }}>
                      <Header attached="top" as="h3" textAlign="left"
                        style={{
                          paddingLeft: "1rem", marginTop: "0", display: "flex",
                          justifyContent: "space-between"
                        }}>
                        <div style={{ justifyContent: "flex-start" }}>
                          {this.state.descName}
                          <Popup content="Retrieved from official NCBI GenBank record."
                            trigger={
                              <Icon style={{ paddingLeft: "0.5rem" }}
                                size="small"
                                color="grey"
                                name="info circle" />
                            } basic inverted />
                        </div>
                        {this.state.accessionCode ?
                          <Popup content="View protein on Uniprot"
                            trigger={
                              <Icon style={{ fontSize: "large", margin: "0" }} color="grey"
                                name="external" onClick={() => openInNewTab(this.state.descLink)} />}
                            basic inverted /> : null}
                      </Header>
                      {this.renderDescription(this.state.descLoadState)}
                    </Card>
                  </Grid>
                  {/* SEQUENCE VISUALIZATION */}
                  <Grid item style={{ paddingTop: "9px" }}>
                    <Card style={{ display: "block", width: "100%" }}>
                      <div>
                        <Header attached="top" as="h3" textAlign="left"
                          style={{
                            marginTop: "0", paddingLeft: "1rem", display: "flex",
                            justifyContent: "space-between"
                          }}>
                          <div style={{ alignItems: "flex-start" }}>
                            NCBI Reference Sequence
                            <Popup content="Retrieved from official NCBI GenBank record."
                              trigger={
                                <Icon style={{ paddingLeft: "0.5rem" }}
                                  size="small"
                                  color="grey"
                                  name="info circle" />
                              } basic inverted />
                          </div>
                          {this.state.accessionCode ?
                            <Popup content="View fully annotated sequence on NCBI"
                              trigger={
                                <Icon style={{ fontSize: "large", margin: "0" }} color="grey"
                                  name="external" onClick={() => openInNewTab(this.state.seqLink)} />}
                              basic inverted /> : null}
                        </Header>
                      </div>
                      <Ref innerRef={this.SeqViewer}>
                        <Card style={{ display: "table", height: viewerHeight, width: "100%", marginTop: "0", border: "none" }}>
                          <SeqViz
                            viewerHeight={viewerHeight}
                            getText={this.getText}
                            style={{ height: viewerHeight, width: "100%" }}
                            viewer="linear"
                            seqStateHandler={this.seqStateHandler}
                            seqLoadState={this.state.seqLoadState}
                            accession={this.state.accessionCode}
                            copyEvent={event => event.key === "c" && (event.metaKey || event.ctrlKey)} />
                        </Card>
                      </Ref>
                    </Card>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </div>
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js